import TCFDetailsContent from './TCFDetailsContent'

export default TCFDetailsContent
